export default __webpack_public_path__ + "static/media/85.b2c4c06e.jpg";